export default {
    label_task:{
        en:"Module and Tasks",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Module/Task",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Module/Task",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Module/Task",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_type:{
        en:"Type",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_url:{
        en:"Url",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_parent:{
        en:"Parent",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    MODULE:{
        en:"MODULE",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    TASK:{
        en:"TASK",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
}